// extracted by mini-css-extract-plugin
module.exports = {"notificationContainer":"OmsTjizHL0M9aLD7IktV_","fadein":"_3RX2EF-957n34MQA8vmPvB","notification":"_2PJFhnoeXGBx5DM5R0EuAW","closeButton":"_1ZnACrPsQa14hTm0roDEAw"};